<template>
	<div>
		<div class="bb-create-own">
            <p class="label">Create your own: <InfoIcon slug="finish-create-own" /></p>
            <div class="buttons uk-flex selected-wood-finish">
                <!-- select/selected wood -->
                <a v-if="selected_wood == null || selected_popular_finish != null" href="#" class="outline" @click.prevent="selectWood">Select Wood</a>
                <div v-else class="wood-sample active" @click.prevent="selectWood">
                    <div class="bb-wood-type">
                        <div class="">
                            <div class="img-container"
                                :style="`background-image: url(${selected_wood.image.webPath}/200);`" alt=""></div>
                            <p>{{ selected_wood.name }} Wood</p>
                            <p class="note">(select to change)</p>
                        </div>
                    </div>
                </div>
                <!-- select/selected finish -->
                <a v-if="selected_finish == null || selected_popular_finish != null" @click.prevent="selectFinish" class="outline" disabled>Select Finish</a>
                <div v-else class="wood-sample active" uk-toggle="target: #finish">
                    <div class="bb-wood-type">
                        <div class="">
                            <div class="img-container"
                                :style="`background-image: url(${selected_finish.image.webPath}/200);`" alt=""></div>
                            <p>{{ selected_finish.name }} Finish</p>
                            <p class="note">(select to change)</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Wood Type Popup -->
        <div id="wood" class="popup" hidden ref="woodsModal">
            <header>
                <div class="uk-flex uk-flex-middle">
                    <div>
                        <p class="label">Select Wood Type:</p>
                    </div>
                    <div style="margin-left: auto;">
                        <button @click.prevent="onCancelSelectWood"><i class="fas fa-times"></i></button>
                    </div>
                </div>
            </header>
            <div class="body">
                <WoodType 
                    @select="onWoodTypeClicked"
                    :selected="local_wood"
                    v-for="wood in woods"
                    :key="wood.id"
                    :wood="wood" />
            </div>
            <footer>
                <div class="uk-flex uk-flex-middle">
                    <a href="#" @click.prevent="onCancelSelectWood">Cancel</a>
                    <a href="#" class="blue" @click.prevent="onWoodTypeSelected">Select</a>
                </div>  
            </footer>
        </div>

        <!-- Finish Type Popup -->
        <div id="finish" class="popup" hidden ref="finishesModal">
            <header>
                <div class="uk-flex uk-flex-middle">
                    <div>
                        <p class="label">Select Wood Finish:</p>
                    </div>
                    <div style="margin-left: auto;">
                        <button @click.prevent="onCancelSelectFinish"><i class="fas fa-times"></i></button>
                    </div>
                </div>
            </header>
            <div class="body">
                <WoodFinish 
                    @select="onFinishTypeClicked"
                    :selected="local_finish"
                    v-for="finish in wood_finishes"
                    :key="finish.id"
                    :finish="finish" />
            </div>
            <footer>
                <div class="uk-flex uk-flex-middle">
                    <a href="#" @click.prevent="onCancelSelectFinish">Cancel</a>
                    <a href="#" class="blue" @click.prevent="onFinishTypeSelected">Select</a>
                </div>  
            </footer>
        </div>
	</div>
</template>

<script>
    import WoodType from '../components/WoodType.vue';
    import WoodFinish from '../components/WoodFinish.vue';
    import InfoIcon from '../components/InfoIcon.vue';
    import {mapState} from 'vuex';

	export default {
		name : "create-own-finish",
		components: {
            WoodType,
            WoodFinish,
            InfoIcon
        },
        data() {
            return {
                local_wood : null,
                local_finish : null
            }
        },
        methods : {
            /**
             * toggle a modal visability
             * @param  {[type]} element [description]
             * @param  {[type]} show    [description]
             * @return {[type]}         [description]
             */
            showModal(element,show){
                if(show){
                    element.removeAttribute('hidden');
                }else{
                    element.setAttribute('hidden',true);
                }
                this.$emit('toggle',show);
            },
            /**
             * user wants to selected a wood
             * check prev selected wood (in store)
             * save locally
             * @return {[type]} [description]
             */
            selectWood(){
                this.local_wood = this.selected_wood;
                //eslint-disable-next-line
                this.showModal(this.$refs.woodsModal,true);
            },
            /**
             * user wants to selected a wood
             * check prev selected wood (in store)
             * save locally
             * @return {[type]} [description]
             */
            selectFinish(){
                // make sure they can actually select a finish
                if(this.selected_popular_finish != null) return;
                
                this.local_finish = this.selected_finish;
                //eslint-disable-next-line
                this.showModal(this.$refs.finishesModal,true);
            },
            /**
             * user clicked on a wood type
             * save it locally.
             * @param  {[type]} wood [description]
             * @return {[type]}      [description]
             */
            onWoodTypeClicked(wood){
                this.local_wood = wood;
            },
            /**
             * user clicked on a finish type
             * save it locally.
             * @param  {[type]} wood [description]
             * @return {[type]}      [description]
             */
            onFinishTypeClicked(finish){
                this.local_finish = finish;
            },
            /**
             * user wants to cancel selected a wood type
             * revert back to previous selection
             * @param  {[type]} wood [description]
             * @return {[type]}      [description]
             */
            onCancelSelectWood(){
                this.local_wood = null;
                //eslint-disable-next-line
                this.showModal(this.$refs.woodsModal,false);
            },
            /**
             * user wants to cancel selected a finish type
             * revert back to previous selection
             * @param  {[type]} wood [description]
             * @return {[type]}      [description]
             */
            onCancelSelectFinish(){
                this.local_finish = null;
                //eslint-disable-next-line
                this.showModal(this.$refs.finishesModal,false);
            },
            /**
             * save local wood type as selected on and close modal.
             * @return {[type]} [description]
             */
            onWoodTypeSelected(){
                //eslint-disable-next-line
                console.log("onWoodTypeSelected");
                this.selected_popular_finish; //helps update store data?
                // clear popular selected.
                this.$store.commit('setSelectedPopularFinish',null);
                // save selected wood.
                this.$store.commit('setSelectedWood',this.local_wood);
                //eslint-disable-next-line
                this.showModal(this.$refs.woodsModal,false);
            },
            /**
             * save local wood type as selected on and close modal.
             * @return {[type]} [description]
             */
            onFinishTypeSelected(){
                //eslint-disable-next-line
                console.log("onFinishTypeSelected");
                this.$store.commit('setSelectedFinish',this.local_finish);
                //eslint-disable-next-line
                this.showModal(this.$refs.finishesModal,false);
            }
        },
        computed : {
            ...mapState({
                woods : state => state.woods,
                wood_finishes : state => state.wood_finishes,
                selected_wood : state => state.selected_wood,
                selected_finish : state => state.selected_finish,
                selected_popular_finish : state => state.selected_popular_finish
            })
        }
	}
</script>